export function humanize(value) {
    return String(value).replace(/_/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2").replace(/^./, (letter) => letter.toUpperCase());
}

export function normalizeFields(fields, items) {
    const source = fields?.length ? fields : Object.keys(items?.[0] || {});
    const seen = new Set();
    return source.map((field) => typeof field === "string" ? { key: field, label: humanize(field) } : { ...field, label: field.label ?? humanize(field.key) })
        .filter((field) => field.key && !seen.has(field.key) && seen.add(field.key));
}

export function getValue(item, key) {
    return String(key).split(".").reduce((value, part) => value?.[part], item);
}

export function formattedValue(item, field) {
    const value = getValue(item, field.key);
    return field.formatter ? field.formatter(value, field.key, item) : value;
}

export function classes(value, item, type = "row") {
    return typeof value === "function" ? value(item, type) : value;
}

export function searchable(value) {
    if (value === null || value === undefined) { return ""; }
    if (typeof value === "object") { return Object.values(value).map(searchable).join(" "); }
    return String(value).toLocaleLowerCase();
}
